export const ANDROID_APP_ID = 'com.vanly.mobileapp';
export const IOS_BUNDLE_ID = 'com.vanly.mobileapp';
export const IOS_APP_ID = '1583417008';

export const APP_STORE_LINKS = {
  ios: `https://apps.apple.com/us/app/vanly/id${IOS_APP_ID}`,
  android: `https://play.google.com/store/apps/details?id=${ANDROID_APP_ID}`,
};
